import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.counterparty['roles']),function(role){return _c(VChip,{staticClass:"mr-2",attrs:{"small":"","label":""}},[_vm._v(" "+_vm._s(_vm.humanize(role))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }